import React from 'react'
import styled from 'styled-components'

const StyledCol = styled.div`
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;

    ${(props) =>
        props.md &&
        `
    @media (min-width: 768px) {
      flex: 0 0 ${(props.md / 12) * 100}%;
      max-width: ${(props.md / 12) * 100}%;
    }
  `}

    ${(props) =>
        props.sm &&
        `
    @media (min-width: 576px) {
      flex: 0 0 ${(props.sm / 12) * 100}%;
      max-width: ${(props.sm / 12) * 100}%;
    }
  `}

  ${(props) =>
        props.lg &&
        `
    @media (min-width: 992px) {
      flex: 0 0 ${(props.lg / 12) * 100}%;
      max-width: ${(props.lg / 12) * 100}%;
    }
  `}
`

const Col = ({ children, ...props }) => {
    return <StyledCol {...props}>{children}</StyledCol>
}

export default Col
